module.exports = __webpack_public_path__ + "img/Indent-Orders-and-Wholesale.21e0ca56.svg";